import _ from 'lodash';

export default {
    computed: {
        config () {
            return window.config;
        },
        appLogo () {
            if (_.isEmpty(this.config.logo)) {
    return '/images/main-logo.png';
  }

  // If config.logo contains a storage path you want to map to /images/...
  // e.g. '/storage/images/2bTeg...png' -> '/images/main-logo.png' (example)
  if (this.config.logo.includes('/storage/images/')) {
    // put your mapping logic here if possible
    return '/images/main-logo.png'; // or do a replace(...)
  }

  return this.config.logo;
        }
    }
}
